<template>
  <div>
    <div
      id="gameWrapper"
      class="game-wrapper"
    >
      <div
        v-if="$store.state.loading"
        class="loading d-flex justify-content-center align-items-center"
      >
        <img
          src="../assets/compact-disc.svg"
          alt=""
        >
      </div>
      <div
        v-if="end"
        class="end-modal d-flex justify-content-center align-items-center"
      >
        <div class="text-center">
          <h2>Ende der Testversion</h2>
          <p>Wenn Du weiterhin Interesse an dem Spiel hast, informiere dich auf <a href="http://sonogame.info/">sonogame.info</a>.</p>
          <a
            href="http://sonogame.info/"
            class="btn btn-secondary"
          >
            Weitere Informationen
          </a>
        </div>
      </div>
      <div
        v-if="solutionModal.visible"
        class="solution-modal d-flex justify-content-center align-items-center"
      >
        <div class="solution-modal-content-wrapper">
          <h3>{{ solutionModal.correct ? 'Richtig!' : 'Falsch..' }}</h3>
          <img
            v-show="solutionModal.correct"
            src="../assets/smile.svg"
            alt=""
          >
          <img
            v-show="!solutionModal.correct"
            src="../assets/frown.svg"
            alt=""
          >
          <div class="mt">
            <button
              v-if="!solutionModal.correct"
              class="btn btn-primary mr"
              @click="solutionModal.visible = false"
            >
              erneut versuchen
            </button>
            <button
              v-if="solutionModal.correct"
              class="btn btn-primary"
              @click="nextRound(), solutionModal.visible = false"
            >
              nächste Runde
            </button>
          </div>
        </div>
      </div>
      <mesh-view
        ref="meshView"
        :tour-current-step="tourCurrentStep"
        :tour-current-target="tourCurrentTarget"
        :is-touch-device="isTouchDevice"
      />
      <slice-view
        ref="sliceView"
        :tour-current-step="tourCurrentStep"
        :tour-current-target="tourCurrentTarget"
        :is-touch-device="isTouchDevice"
      />
      <solutions
        ref="solutions"
        :tour-current-step="tourCurrentStep"
        :tour-current-target="tourCurrentTarget"
        :is-touch-device="isTouchDevice"
        @solutionModal="solutionModal = $event"
      />
    </div>
    <div
      v-if="isTouchDevice"
      id="mobileRotateController"
      class="mobile-rotation-controller"
    >
      <p class="text-center m-0">
        Rotation
      </p>
    </div>
    <div
      v-if="isTouchDevice"
      id="mobileMoveController"
      class="mobile-move-controller"
    >
      <p class="text-center m-0">
        Bewegung Sonde
      </p>
    </div>
    <div class="footer">
      <div class="container">
        <div class="d-flex align-items-center">
          <div class="level">
            <!-- <h5>Level {{ getGameType(getRoundInfo().gameType) }}</h5> -->
            <div
              v-for="(round, index) in getCurrentGame().rounds"
              :key="round.name"
              class="level-progress"
            >
              <!-- {{ getCurrentGames() }} -->
              <div class="type-icon">
                <img
                  :src="getGameTypePath(round.gameType)"
                  alt=""
                >
              </div>
              <div class="progress-wrapper">
                <div
                  class="box"
                  :class="{'active': $store.state.currentRound === index}"
                />
                <div
                  v-if="getCurrentGame().rounds[index+1]"
                  class="line"
                />
              </div>
            </div>
          </div>
          <div class="buttons">
            <button
              v-if="$store.state.currentGame === 0"
              class="btn btn-green"
              @click="loadLevel(1, 0)"
            >
              <i class="fas fa-play" />
              Spiel starten
            </button>
            <!-- <button
              v-else
              class="btn btn-green"
              @click="loadLevel($store.state.currentGame + 1, 0)"
            >
              <i class="fas fa-play" />
              Spiel überspringen
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MeshView from '@/components/MeshView'
import SliceView from '@/components/SliceView'
import Solutions from '@/components/Solutions'
import nipplejs from 'nipplejs'
import Level from '@/lib/level'

// import * as Stats from 'stats.js'

// var stats = new Stats()
// stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom)

export default {
  name: 'GameController',
  components: {
    MeshView,
    Solutions,
    SliceView
  },
  props: {
    isTouchDevice: {
      type: Boolean,
      default: undefined
    },
    tourCurrentStep: {
      type: Number,
      default: undefined
    },
    tourCurrentTarget: {
      type: String,
      default: undefined
    }
  },
  data: function () {
    return {
      moveForwardPressed: false,
      moveBackwardPressed: false,
      moveLeftPressed: false,
      moveRightPressed: false,

      rotateForwardPressed: false,
      rotateBackwardPressed: false,
      rotateLeftPressed: false,
      rotateRightPressed: false,
      rotateSolutionLeft: false,
      rotateSolutionRight: false,

      mobileRotateController: undefined,
      mobileMoveController: undefined,
      mobileRotateControllerManager: undefined,
      mobileMoveControllerManager: undefined,

      end: false,

      solutionModal: {
        visible: false,
        correct: false
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    this.mobileRotateController = document.getElementById(`mobileRotateController`)
    this.mobileMoveController = document.getElementById(`mobileMoveController`)
    window.addEventListener('keyup', this.handleKeyUp)
    window.addEventListener('keydown', this.handleKeyDown)
    this.$store.commit('setLoading', true)
    if (this.isTouchDevice) {
      let mobileRotateControllerOptions = {
        zone: this.mobileRotateController,
        color: '#AADDF8',
        size: 150,
        threshold: 100,
        fadeTime: 0,
        position: { x: this.mobileRotateController.getBoundingClientRect().left + (this.mobileRotateController.offsetWidth / 2), y: this.mobileRotateController.getBoundingClientRect().top + (this.mobileRotateController.offsetHeight / 2) },
        mode: 'static'
      }
      this.mobileRotateControllerManager = nipplejs.create(mobileRotateControllerOptions)
      this.mobileRotateControllerManager.on('move', this.handleRotateControllerMove)
      this.mobileRotateControllerManager.on('end', this.handleRotateControllerEnd)

      let mobileMoveControllerOptions = {
        zone: this.mobileMoveController,
        color: '#AADDF8',
        size: 150,
        threshold: 100,
        fadeTime: 0,
        position: { x: this.mobileMoveController.getBoundingClientRect().left + (this.mobileMoveController.offsetWidth / 2), y: this.mobileMoveController.getBoundingClientRect().top + (this.mobileMoveController.offsetHeight / 2) },
        mode: 'static'
      }
      this.mobileMoveControllerManager = nipplejs.create(mobileMoveControllerOptions)
      this.mobileMoveControllerManager.on('move', this.handleMobileMoveControllerMove)
      this.mobileMoveControllerManager.on('end', this.handleMobileMoveControllerEnd)
    }
    this.loadLevel(0, 0)
    this.render()
  },
  methods: {
    onResize () {
      this.$refs.meshView.setSize()
      this.$refs.sliceView.setSize()
      this.$refs.solutions.setSize()
    },
    nextRound () {
      this.$store.commit('setLoading', true)

      if (Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound + 1]) {
        this.loadLevel(this.$store.state.currentGame, this.$store.state.currentRound + 1)
      } else if (Level[this.$store.state.currentGame + 1]) {
        this.loadLevel(this.$store.state.currentGame + 1, 0)
      } else {
        this.end = true
      }
    },
    getGameType (gameType) {
      switch (gameType) {
        case 'COLOR':
          return 'Farbe'
        case 'GRAY':
          return 'Schwarz/Weiß'
        case 'OUTLINE':
          return 'Ultraschall'
      }
    },
    getGameTypePath (gameType) {
      switch (gameType) {
        case 'COLOR':
          return './stufeColor.svg'
        case 'GRAY':
          return './stufeGray.svg'
        case 'OUTLINE':
          return './stufeOutline.svg'
      }
    },
    getRoundInfo () {
      if (this.$store.state.currentGame && this.$store.state.currentRound) {
        return Level[this.$store.state.currentGame].rounds[this.$store.state.currentRound]
      }
    },
    getCurrentGame () {
      return Level[this.$store.state.currentGame]
    },
    render () {
      // stats.update()
      this.handleInputs()
      this.$refs.sliceView.render()
      this.$refs.meshView.render()
      this.$refs.solutions.render()
      requestAnimationFrame(() => {
        this.render()
      })
    },
    async loadLevel (gameToLoad, roundToLoad) {
      this.$store.commit('setCurrentGame', gameToLoad)
      this.$store.commit('setCurrentRound', roundToLoad)
      await this.$refs.sliceView.loadLevel(gameToLoad, roundToLoad)
      await this.$refs.meshView.loadLevel()
      await this.$refs.solutions.loadLevel(gameToLoad, roundToLoad)
    },
    handleKeyDown (event) {
      switch (event.code) {
        case 'KeyW':
          this.rotateForwardPressed = true
          break
        case 'KeyS':
          this.rotateBackwardPressed = true
          break
        case 'KeyA':
          this.rotateLeftPressed = true
          break
        case 'KeyD':
          this.rotateRightPressed = true
          break
        case 'KeyQ':
          this.rotateSolutionLeft = true
          break
        case 'KeyE':
          this.rotateSolutionRight = true
          break
        case 'KeyC':
          this.cameraFree = !this.cameraFree
          break
      }
    },
    handleKeyUp (event) {
      switch (event.code) {
        case 'KeyW':
          this.rotateForwardPressed = false
          break
        case 'KeyS':
          this.rotateBackwardPressed = false
          break
        case 'KeyA':
          this.rotateLeftPressed = false
          break
        case 'KeyD':
          this.rotateRightPressed = false
          break
        case 'KeyQ':
          this.rotateSolutionLeft = false
          break
        case 'KeyE':
          this.rotateSolutionRight = false
          break
      }
    },
    handleRotateControllerMove (evt, movement) {
      if (movement.angle.degree <= 67.5 || movement.angle.degree >= 292.5) {
        this.rotateRightPressed = true
      } else {
        this.rotateRightPressed = false
      }
      if (movement.angle.degree <= 157.5 && movement.angle.degree >= 22.5) {
        this.rotateForwardPressed = true
      } else {
        this.rotateForwardPressed = false
      }
      if (movement.angle.degree <= 247.5 && movement.angle.degree >= 112.5) {
        this.rotateLeftPressed = true
      } else {
        this.rotateLeftPressed = false
      }
      if (movement.angle.degree <= 337.5 && movement.angle.degree >= 202.5) {
        this.rotateBackwardPressed = true
      } else {
        this.rotateBackwardPressed = false
      }
    },
    handleRotateControllerEnd () {
      this.rotateRightPressed = false
      this.rotateForwardPressed = false
      this.rotateLeftPressed = false
      this.rotateBackwardPressed = false
    },
    handleMobileMoveControllerMove (evt, movement) {
      if (movement.angle.degree <= 67.5 || movement.angle.degree >= 292.5) {
        this.moveRightPressed = true
      } else {
        this.moveRightPressed = false
      }
      if (movement.angle.degree <= 157.5 && movement.angle.degree >= 22.5) {
        this.moveForwardPressed = true
      } else {
        this.moveForwardPressed = false
      }
      if (movement.angle.degree <= 247.5 && movement.angle.degree >= 112.5) {
        this.moveLeftPressed = true
      } else {
        this.moveLeftPressed = false
      }
      if (movement.angle.degree <= 337.5 && movement.angle.degree >= 202.5) {
        this.moveBackwardPressed = true
      } else {
        this.moveBackwardPressed = false
      }
    },
    handleMobileMoveControllerEnd () {
      this.moveRightPressed = false
      this.moveForwardPressed = false
      this.moveLeftPressed = false
      this.moveBackwardPressed = false
    },
    handleInputs () {
      if ((this.rotateForwardPressed) && this.$store.state.rotateXZ <= (2 - this.$store.state.speed)) {
        this.$store.commit('setRotateXZ', this.$store.state.rotateXZ + (this.$store.state.speed / 3))
      }
      if ((this.rotateBackwardPressed) && this.$store.state.rotateXZ >= (1 + (this.$store.state.speed / 2))) {
        this.$store.commit('setRotateXZ', this.$store.state.rotateXZ - (this.$store.state.speed / 3))
      }
      if (this.rotateRightPressed) {
        this.$store.commit('setRotateY', this.$store.state.rotateY + (this.$store.state.speed / 2))
      }
      if (this.rotateLeftPressed) {
        this.$store.commit('setRotateY', this.$store.state.rotateY - (this.$store.state.speed / 2))
      }
      if (this.rotateSolutionRight) {
        this.$store.commit('setRotateSolution', this.$store.state.rotateSolution + this.$store.state.speed)
      }
      if (this.rotateSolutionLeft) {
        this.$store.commit('setRotateSolution', this.$store.state.rotateSolution - this.$store.state.speed)
      }
      if ((this.moveForwardPressed) && this.$store.state.mouseYRelative >= (0 + this.$store.state.speed)) {
        this.$store.commit('setMouseYRelative', this.$store.state.mouseYRelative - this.$store.state.speed / 2)
      }
      if ((this.moveBackwardPressed) && this.$store.state.mouseYRelative <= (1 - this.$store.state.speed)) {
        this.$store.commit('setMouseYRelative', this.$store.state.mouseYRelative + this.$store.state.speed / 2)
      }
      if (this.moveRightPressed && this.$store.state.mouseXRelative <= (1 - this.$store.state.speed)) {
        this.$store.commit('setMouseXRelative', this.$store.state.mouseXRelative + this.$store.state.speed / 2)
      }
      if (this.moveLeftPressed && this.$store.state.mouseXRelative >= (0 + this.$store.state.speed)) {
        this.$store.commit('setMouseXRelative', this.$store.state.mouseXRelative - this.$store.state.speed / 2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style.scss';
.footer{
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  .level{
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  .buttons{
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
}
.mobile-move-controller{
  height: 25vh;
  // background-color: rgba(green, 0.5);
  position: fixed;
  bottom: 100px;
  right: 0;
  left: 50%;

 -ms-user-select: None;
 -moz-user-select: None;
 -webkit-user-select: None;
}
.mobile-rotation-controller{
  height: 25vh;
  // background-color: rgba($cyan, 0.5);
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 50%;

 -ms-user-select: None;
 -moz-user-select: None;
 -webkit-user-select: None;
}
.game-wrapper{
  height: 40vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas: "sol sol" "mesh slice" "mesh slice";
  grid-column-gap: $gutter;
  grid-row-gap: $gutter;
  position: relative;

  .solution-modal, .loading, .end-modal{
    z-index: 1040;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba($color: $cyan, $alpha: 0.5);
  }
  .loading, .end-modal{
    background-color: $cyan;
    color: $bg-light;
  }
  .solution-modal{
    .solution-modal-content-wrapper{
      text-align: center;
      color: $bg-light;
      img{
        width: 150px;
      }
    }
  }
  .loading{
    img{
      width: 100px;
      animation-name: spin;
      animation-duration: 5000ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

  }

  @keyframes spin {
      from {
          transform:rotate(0deg);
      }
      to {
          transform:rotate(360deg);
      }
  }
}
  .level{
    .level-progress{
        display: inline-block;
      .type-icon{
        img{
          width: 30px;
          height: 30px;
        }
      }
      .progress-wrapper{
        display: inline-flex;
        align-items: center;
        .box{
          width: 20px;
          height: 20px;
          background-color: rgba($color: $cyan, $alpha: 0.2);
          &.active{
            background-color: $cyan;
          }
        }
        .line{
          width: 70px;
          height: 3px;
          background-color: rgba($color: $cyan, $alpha: 0.2);
        }
      }
    }
  }

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
.mobile-move-controller{
  height: 20vh;
  // background-color: rgba(green, 0.5);
  position: fixed;
  bottom: 100px;
  right: 0;
  left: 60%;

 -ms-user-select: None;
 -moz-user-select: None;
 -webkit-user-select: None;
}
.mobile-rotation-controller{
  height: 20vh;
  // background-color: rgba($cyan, 0.5);
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 60%;

 -ms-user-select: None;
 -moz-user-select: None;
 -webkit-user-select: None;
}

}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .game-wrapper{
    height: 55vh;
    grid-template-columns: 5fr 5fr 2fr;
    grid-template-rows: 1fr;
    grid-template-areas: "mesh slice sol";
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {

}
</style>
